globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.Controllers.Websites.LegalNoticeFormSubmissionController = (function(superClass) {

    utils.extend(LegalNoticeFormSubmissionController, superClass);

    function LegalNoticeFormSubmissionController() {
      this.$body          = $("body");
      this.$targetContent = this.$body.find(".content-legal-notice-form-submissions");
      this.$form          = this.$targetContent.find("form.edit_legal_notice_form_submission");
    }

    LegalNoticeFormSubmissionController.prototype = {
      init: function() {
        var controller = this;

        appCustomerSpace.LimitlessPlugins.initPlugins(controller.$body);
        appCustomerSpace.LimitlessPlugins.Validation.errors({ $form: controller.$form, errors: flash.errors });

        controller.$targetContent.on("click", 'button[type="submit"]', function() {
          appCustomerSpace.Loader().start();
          controller.$form.submit();
        })

        if(controller.$body.hasClass("legal-notice-form-submissions-activity") || controller.$body.hasClass("legal-notice-form-submissions-invalid-organization-type")) {
          appCustomerSpace.legalNoticeActivityStepController = new appCustomerSpace.LegalNoticeActivityStepController();
          appCustomerSpace.legalNoticeActivityStepController.init();
        }
        if(controller.$body.hasClass("legal-notice-form-submissions-agency-webmaster")) {
          appCustomerSpace.legalNoticeAgencyWebmasterStepController = new appCustomerSpace.LegalNoticeAgencyWebmasterStepController();
          appCustomerSpace.legalNoticeAgencyWebmasterStepController.init();
        }
        if(controller.$body.hasClass("legal-notice-form-submissions-confirmation")) {
          appCustomerSpace.legalNoticeConfirmationStepController = new appCustomerSpace.LegalNoticeConfirmationStepController();
          appCustomerSpace.legalNoticeConfirmationStepController.init();
        }
        if(controller.$body.hasClass("legal-notice-form-submissions-general")) {
          appCustomerSpace.legalNoticeGeneralStepController = new appCustomerSpace.LegalNoticeGeneralStepController();
          appCustomerSpace.legalNoticeGeneralStepController.init();
        }
        if(controller.$body.hasClass("legal-notice-form-submissions-hosting-company")) {
          appCustomerSpace.legalNoticeHostingCompanyStepController = new appCustomerSpace.LegalNoticeHostingCompanyStepController();
          appCustomerSpace.legalNoticeHostingCompanyStepController.init();
        }
        if(controller.$body.hasClass("legal-notice-form-submissions-validation")) {
          appCustomerSpace.legalNoticeValidationStepController = new appCustomerSpace.LegalNoticeValidationStepController();
          appCustomerSpace.legalNoticeValidationStepController.init();
        }
      }
    }

  return LegalNoticeFormSubmissionController;

})(appCustomerSpace.Controllers.MainController);
